﻿<script lang="ts" setup>
    import { reactive } from 'vue';
    import { type ListsReference, type AddedLists } from './FormEditor.access';
    import { addItemToList } from './FormEditor';
    import BSFormSearch from '@shared/components/BSFormSearch.vue';

    const props = defineProps<{
        lists: AddedLists;
        accountLists: ListsReference[];
    }>();

    let listsToAdd: ListsReference[] = [];

    const state = reactive<{
        listsFilter: string;
    }>({
        listsFilter: '',
    });

    const getListsToAdd = () => {
        listsToAdd = [];
        props.accountLists.forEach((list: ListsReference) => {
            let match = props.lists.find((listInForm: any) => {
                return list.ListId === listInForm.id;
            });

            let filterMatch = list.Name.toLowerCase().indexOf(state.listsFilter.toLowerCase()) > -1;

            if (!match && (!state.listsFilter || filterMatch)) listsToAdd.push(list);
        });
        return listsToAdd;
    };
</script>

<template>
    <BSFormSearch class="form-group" v-model="state.listsFilter" @reset="state.listsFilter = ''"></BSFormSearch>

    <TransitionGroup tag="ul" name="list" class="list-unstyled list-border-divider list-item-state-hover m-lg-b">
        <li class="p-sm-t p-lg-l p-lg-r" v-for="list in getListsToAdd()" :key="list.ListId">
            <div class="d-flex align-items-center">
                <h4 class="m-0-t">{{ list.Name }}</h4>
                <div class="m-sm-b m-auto-l text-nowrap">
                    <button
                        type="button"
                        class="btn btn-primary btn-sm"
                        @click="
                            addItemToList(props.lists, {
                                label: list.Name,
                                id: list.ListId,
                            })
                        ">
                        {{ $Resources.FormEditorAddListBtn }}
                    </button>
                </div>
            </div>
        </li>
    </TransitionGroup>
</template>

<style></style>

<style scoped></style>
